module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-ford.b43475d5.png";